import { arrayOf, bool, func, shape } from "prop-types";

import __ from "web/Layout/Translations";

import isArrayHasItems from "web/utils/data/validator/array/isArrayHasItems";

import classes from "./dropdown.scss";

const Dropdown = ({ options, onChange, darkMode }) => {
  const classNameOption = darkMode ? classes.optionDark : classes.option;
  return (
    <div className={classes.root}>
      {options?.map((option) => {
        return (
          <div className={classes.group} key={option.name || option.label}>
            {isArrayHasItems(option.direction) ? (
              option.direction.map((directionItem) => (
                <button
                  key={`${option.name}${directionItem.name}`}
                  className={classNameOption}
                  type="button"
                  data-t2={option.name || option.label}
                  data-t1="dropdown_option_button"
                  onClick={() => {
                    onChange({
                      name: option.name,
                      direction: directionItem.name,
                    });
                  }}
                >
                  <span
                    className={classes.label}
                    data-t1={`${option.name || option.label}_span`}
                  >
                    {__(option.label)}:
                  </span>{" "}
                  {__(directionItem.label)}
                </button>
              ))
            ) : (
              <button
                className={classes.option}
                type="button"
                data-t2={option.name || option.label}
                data-t1="dropdown_option_button"
                onClick={() => {
                  onChange({
                    name: option.name,
                  });
                }}
              >
                <span
                  className={classes.label}
                  data-t1={`${option.name || option.label}_span`}
                >
                  {__(option.label)}
                  {option.name && ":"}
                </span>
              </button>
            )}
          </div>
        );
      })}
    </div>
  );
};

Dropdown.propTypes = {
  onChange: func.isRequired,
  darkMode: bool,
  options: arrayOf(shape({})).isRequired,
};

Dropdown.defaultProps = {
  darkMode: false,
};

export default Dropdown;
